import React from 'react';
import { Icon } from '../../common/AppShell';

const Orders = () => {
  const demoOrders = [
    { id: 1258, name: 'Новый раздел', time: 'скоро', status: 'Push later', amount: '—' },
    { id: 1257, name: 'Уведомления', time: 'позже', status: 'В плане', amount: '—' },
  ];

  return (
    <section className="screen-stack">
      <div className="segmented-control">
        <button className="active">Все</button>
        <button>Новые</button>
        <button>Готовятся</button>
      </div>

      <div className="empty-feature-card">
        <div className="feature-icon">
          <Icon name="notifications_active" />
        </div>
        <div>
          <h2>Заказы и push-уведомления</h2>
          <p>Раздел подготовлен в интерфейсе. Подключение live-заказов и push добавим следующим этапом.</p>
        </div>
      </div>

      <div className="list-card">
        {demoOrders.map((order) => (
          <div className="order-row" key={order.id}>
            <span className="status-dot green" />
            <div className="order-main">
              <strong>#{order.id}</strong>
              <span>{order.name}</span>
            </div>
            <div className="order-side">
              <span>{order.time}</span>
              <strong>{order.amount}</strong>
              <em>{order.status}</em>
            </div>
            <Icon name="chevron_right" className="muted-icon" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Orders;
